module.exports = __webpack_public_path__ + "img/Travel Icon - charcoal.61379111.svg";